import { Button } from "@/components/shared/buttons/Button";
import PublishIcon from "@mui/icons-material/Publish";
import { useDialogs } from "@toolpad/core";
import { BulkImportDialog } from "../dialogs/bulk-import-dialog/BulkImportDialog";

/**
 * ClausesImportButton component
 */
export const ClausesImportButton = () => {
    const dialogs = useDialogs();

    const handleClick = () => {
        dialogs.open(BulkImportDialog);
    };

    return (
        <Button
            type="button"
            sx={{ borderRadius: 22 }}
            variant="contained"
            disableElevation
            loadingPosition="end"
            startIcon={<PublishIcon />}
            onClick={handleClick}
        >
            Bulk Import
        </Button>
    );
};
